import { getConfig } from '@/lib/get-config';
import { type BaseInstance, type ModelName } from '@pigello/pigello-matrix';
import { fetchApi } from '.';
import { toInternalFieldNames } from '../instanceMapper';
import { buildBackendUrl, handleApiResponse } from './utils';

type Get = {
  modelName: ModelName;
  id?: string;
  revalidate?: number;
  overrideUrl?: string;
  /** Opt in to `refresh_get` on file fields; each one costs a rate-limited signing call */
  fileRefreshUrls?: boolean;
};

export async function get<T extends BaseInstance>({
  id,
  modelName,
  overrideUrl,
  revalidate,
  fileRefreshUrls,
}: Get) {
  const config = getConfig<ModelName, T>(modelName, true);

  if (!config) {
    throw new Error(`No config found for model ${modelName}`);
  }

  const backendUrl = buildBackendUrl(config, id, overrideUrl);

  const completeUrl = fileRefreshUrls
    ? `${backendUrl}?_file_refresh_urls=true`
    : `${backendUrl}`;

  const res = await fetchApi({
    method: 'GET',
    next: {
      revalidate,
    },
    url: completeUrl,
  });

  const data = await handleApiResponse<T>(res);

  return toInternalFieldNames<T>(config, data);
}
